import { render } from "./mainContent.vue?vue&type=template&id=cb629168"
import script from "./mainContent.vue?vue&type=script&lang=js"
export * from "./mainContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__